import { Product } from '../components/shared/ProductCard/ProductCard';

export const products: Record<string, Product> = {
  wholesale: {
    id: 'wholesale',
    name: 'Wholesale Recyclable Rib-n-Dip',
    price: 'Starting at 1.15¢ per cup',
    description:
      'Perfect for BBQ joints, food trucks, and takeout trays. Made from recyclable materials and designed for high-volume service.',
    features: [
      'Bulk packs: 1,000 / 2,000 / 5,000 units',
      'Stackable and space-saving',
      'Fits standard rib sizes',
      'Reduces sauce waste',
      'Made from recyclable materials',
    ],
    inStock: false,
  },
  ceramic: {
    id: 'ceramic',
    name: 'Premium Ceramic Rib-n-Dip',
    price: '$34.99',
    description:
      'The ultimate gift for BBQ masters. Beautiful glazed ceramic, dishwasher-safe, and built to last a lifetime.',
    features: [
      'Premium glaze finish',
      'Dishwasher & microwave safe',
      'Perfect for home grilling',
      'Lifetime durability guarantee',
    ],
    inStock: false,

  },
  pets: {
    id: 'pets',
    name: 'Bark-n-Dip: Pup Edition',
    price: 'Priceless — just like your dog',
    description:
      "The dunk they've been begging for — and those eyes are pointed right at you. A paw-sized cup plus a rib-shaped bone treat so good your good boy does the full-body happy wiggle. Zoomies sold separately.",
    features: [
      'Paw-sized cup with a drool-proof grip',
      'Rib-shaped bone treat built for maximum chomp',
      'Vet-friendly recipe — no onion, no garlic, all good boy',
      'Clinically adorable* (*9 in 6 dogs agree)',
    ],
    inStock: false,
    badge: 'NEW · FUR THE PUPS',
  },
};
